export const tablePageSizes = [5, 10, 25, 50];
export const MAX_PAGES = 5;

export const orderType = {
  ASC: "asc",
  DESC: "desc",
};
